<unity-dialog-shared [title]="$title()" (closeEvent)="onClose(false)">
  <ng-content ngProjectAs="[dialog-body]">
    <ng-content />
  </ng-content>
  <ng-content ngProjectAs="[dialog-actions]">
    <button kendoButton type="button" (click)="onClose(false)">No, I changed my mind.</button>
    <button kendoButton type="button" themeColor="secondary" (click)="onClose(true)">Yes, confirmed.</button>
  </ng-content>
</unity-dialog-shared>
